import React, { FC } from 'react';

import Pill from '@/components/UI/Pill/Pill';
import { ConflictElement } from '@/types/Conflicten';
import { timeWithDayOfWeekWithTime } from '@/utils/dateUtils';

import {
  geefDienstregelpuntVoorElement,
  geefInzetOmschrijvingVoorConflict,
  geefTijdstipVoorElement,
} from '../../../utils/conflict';

import plankStyles from '../../../PlankView.module.css';
import styles from '../Conflict.module.css';

const ConflictToelichting: FC<{ element: ConflictElement | undefined }> = ({ element }) => {
  const toelichting = `${timeWithDayOfWeekWithTime(geefTijdstipVoorElement(element))} ${geefDienstregelpuntVoorElement(element)} ${geefInzetOmschrijvingVoorConflict(element)}`;

  return (
    <div className={styles.toelichtingRowStyle}>
      <span title={toelichting} className={`${plankStyles.toelichtingStyle} ${styles.toelichtingTextStyle}`}>
        {toelichting}
      </span>
      {/* Toont de bijzonderheidscode van de huidige inzet als tag; toont de code altijd volledig
       * en kapt zo nodig in plaats daarvan de toelichtingstekst ernaast af (zie flex/ellipsis
       * hierboven). */}
      {element?.bijzonderheidscode && (
        <Pill variant='info' size='small' className={styles.bijzonderheidscodeTagStyle}>
          {element.bijzonderheidscode}
        </Pill>
      )}
    </div>
  );
};
export default ConflictToelichting;
